var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContainer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 66,
    viewBox: "0 0 73 66",
    fill: "none",
    id: "svg3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 65H71.7368V15.72H1V40.36V65Z",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    id: "path1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.53 54.44H46.2008V1H12.53V27.688V54.44Z",
    fill: "white",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    id: "path2",
    style: {
      fill: "none"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3464 23.5281V45.8641H61.0559V23.5281H46.2012H31.3464Z",
    fill: "#845EC2",
    id: "path3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer);
export default __webpack_public_path__ + "static/media/container.9f85577df31f4159a5d525d0109d7392.svg";
export { ForwardRef as ReactComponent };